import { ConfigProvider } from "antd";
import "styles/app.scss";

import locale from "antd/locale/es_ES";

//Setup antd theme config
export default function ThemeConfigProvider(props) {
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        // algorithm: theme.darkAlgorithm,
        token: {
          // Seed Token
          colorBgGradient: "linear-gradient(135deg, #FFE8FC 20%, #E2F7FF)",
          colorPrimary: "#1C5676", //Navy blue
          colorLink: "#1C5676", //Navy blue
          colorSecondary: "#801794", //Violet
          colorBgSecondary: "#F9F3F7", //Light pink
          colorBgTertiary: "#E2F7FF", //Light blue
          colorError: "#DA2626", //Bright red
          colorGold: "#518038", //Dark yellow
          colorSucess: "#00750A", //Bright green
          colorGray: "gray", //Gray
          colorLightGray: "#f6f6f6", //Light gray
        },

        components: {
          Progress: {
            circleTextFontSize: "10px",
            circleIconFontSize: "15px",
          },
        },
      }}
    >
      {props.children}
    </ConfigProvider>
  );
}
